import { httpPost } from './request/index'

//  角色配置列表查询
export function roleList (data) {
  return httpPost('/cloud/cus/user/getRoleList', data)
}

// 角色配置中关联用户查看
export function userList (data) {
  return httpPost('/cloud/cus/user/getUsers', data)
}

// 角色配置删除
export function delRole (data) {
  return httpPost('/cloud/cus/user/delRole', data)
}

// 角色配置菜单权限查询
export function menuList (data) {
  return httpPost('/cloud/cus/user/getRoleMenuList', data)
}

// 角色配置中的查看
export function roleInfo (data) {
  return httpPost('/cloud/cus/user/getRoleInfo', data)
}

// 角色配置添加 编辑
export function addRole (data) {
  return httpPost('/cloud/cus/user/addRoleAndMenu', data)
}

// 账户配置查询列表
export function accountList (data) {
  return httpPost('/cloud/cus/user/list', data)
}

// 账号配置新增/编辑提交
export function addUser (data) {
  return httpPost('/cloud/cus/user/addEditUser', data)
}

//  账号配置新增中账号获取省市信息
export function cityInfo (data) {
  return httpPost('/cloud/cus/user/getProvinceCityInfo')
}

// 账号配置新增中的商户名称
export function merchantList (data) {
  return httpPost('/cloud/cus/user/getMerChantInfo', data)
}

export function userRoleList (data) {
  return httpPost('/cloud/cus/user/getRelationRole', data)
}

// 账号配置新增中的设备管理查询
export function areaInfo (data) {
  return httpPost('/cloud/cus/user/getAreaInfoList', data)
}

// 日志
export function logList (data) {
  return httpPost('/sys/log/list', data)
}

// 账号配置列表中的管理设备查询
export function productList (id) {
  const data = {
    cuUserId: id
  }
  return httpPost('/cloud/cus/user/getProductListInfo', data)
}

// 账号配置-角色查询菜单
export function roleFindMenu (data) {
  return httpPost('/cloud/cus/user/getMenuListByRole', data)
}

// 删除用户
export function delUser (id) {
  const data = {
    id
  }
  return httpPost('/cloud/cus/user/delUser', data)
}

export function userDetail (data) {
  return httpPost('/cloud/cus/user/getUserInfo', data)
}

// 卡号查询
export function cardNum (cardNumber) {
  const data = {
    cardNumber
  }
  return httpPost('/cloud/cus/user/getCardNum', data)
}

// 小程序配置查询
export function getApplet () {
  return httpPost('/cloud/cus/extend/getExtendInfo')
}

// 小程序配置添加和修改
export function upDateApplet (data) {
  return httpPost('/cloud/cus/extend/editExtend', data)
}

//限制提现金额
export function updateWithdrawAmount (data) {
  return httpPost('/cloud/cus/extend/updateWithdrawAmount', data)
}
// 从监管系统异国恋
export function getProductList (data) {
  return httpPost('/product/getProductList', data)
}
// 投递不规范监管
export function getWebcamAlarmPhoto (data) {
  return httpPost('/AiCamera/getWebcamAlarmPhoto', data)
}

export function getRecordPhotos (data) {
  return httpPost('/equipment/operation/getRecordPhotos', data)
}
export function getProductPhoto (data) {
  return httpPost('/product/getProductPhoto', data)
}

export function getUserLvRanking (data) {
  return httpPost('/cloud/cus/user/getUserLvRanking', data)
}

// 内外部图片
export function getPhotoList (data) {
  return httpPost('product/getPhotoList', data)
}

// 视频
export function getDeviceVideo (data) {
  return httpPost('/product/getDeviceVideo', data)
}

// 根据新的点位 出的搜索接口
export function getEstateZyProduct (data) {
  return httpPost('/product/getEstateZyProduct', data)
}

// 根据旧的点位 出的搜索接口
export function getEstateProduct (data) {
  return httpPost('/product/getEstateProduct', data)
}

// 工作人员录入，坦克
export function getZyProductListInfo (data) {
  return httpPost('/cloud/cus/user/getZyProductListInfo', data)
}

// 小区列表奖惩
export function getGradeEstateList (data) {
  return httpPost('/estate/getGradeEstateList', data)
}

// 获取奖惩信息
export function getIsGradeEstate (data) {
  return httpPost('/estate/getIsGradeEstate', data)
}

// 编辑奖惩
export function configGrade (data) {
  return httpPost('/estate/configGrade', data)
}
